import { apiSlice } from "../../api-slice";
import { StatusProposalRequirement, StatusProposalRequirements } from "./proposal-attachment-requirements-api-state";

export const proposalAttachmentRequirementsAPI = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getProposalAttachmentRequirementsStatus: builder.query<StatusProposalRequirement[], { proposalID: number }>({
            query: ({ proposalID }) => `/api/installation-requirements/applications/${proposalID}/requirements-status`,
            transformResponse: (response: StatusProposalRequirements) => response.data,
            transformErrorResponse: (response: any) => response.data,
            providesTags: (result, error, { proposalID }) => [
                { type: "ProposalFiles", id: proposalID },
                { type: 'ProposalFiles', id: 'LIST' },
                { type: "Proposal", id: proposalID },
                { type: 'Proposal', id: 'LIST' },
            ],
        }),
        viewAttachmentFile: builder.query<Blob, string>({
            query: (path) => ({
                url: `/api/installation-requirements/view-file?path=${encodeURIComponent(path)}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
        }),
        uploadRequirementFile: builder.mutation< any, { proposalID: number; file: File, key: string;}>({
            query: ({ proposalID, file, key }) => {
                const formData = new FormData();
                formData.append(key, file);
                return {
                    url: `api/installation-requirements/applications/${proposalID}/upload-requirements`,
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: (result, error, { proposalID }) => [
                { type: "ProposalFiles", id: "LIST" },
                { type: "ProposalFiles", id: proposalID },
                { type: "Proposal", id: "LIST" },
                { type: "Proposal", id: proposalID },
            ],
        }),
    })
})

export const {
    useGetProposalAttachmentRequirementsStatusQuery,
    useLazyViewAttachmentFileQuery,
    useUploadRequirementFileMutation,
} = proposalAttachmentRequirementsAPI